
const FAQContentType = Symbol();

export class FAQContent {
    [FAQContentType]: any;
    readonly value: string;

    private constructor(faqContent: string) {
        this.value = faqContent;
    }

    static isInvalidSize(title: string): boolean {
        return title.length < 1 || title.length > 1000;
    }

    static messageInvalidSize(label: string): string {
        return `${label}は1文字以上1000文字以下で入力してください。`;
    }

    static fromString(faqContent: string): FAQContent {
        return new FAQContent(faqContent);
    }
}
